import { useState } from "react";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "../../layouts/DashboardLayout";
import { markAttendance } from "../../services/attendanceService";
import "./AddAttendance.css";

export default function AddAttendance() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    memberName: "",
    date: "",
    status: "Present",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async () => {
    // Validation
    if (!formData.memberName.trim()) {
      alert("Please enter Member Name");
      return;
    }

    if (!formData.date) {
      alert("Please select Attendance Date");
      return;
    }

    if (!formData.status) {
      alert("Please select Attendance Status");
      return;
    }

    try {
      await markAttendance(formData);

      alert("Attendance Marked Successfully");

      navigate("/attendance");
    } catch (error) {
      console.error(error);
      alert("Error Marking Attendance");
    }
  };

  return (
    <DashboardLayout>
      <div className="attendance-form-page">
        <div className="attendance-form-header">
          <h1>Mark Attendance</h1>
          <p style={{ fontWeight: "bold", color: "white" }}>
            Record member attendance and track daily gym activity.
          </p>
        </div>

        <div className="attendance-form-card">
          <div className="attendance-icon">✓</div>

          <h2>Attendance Entry</h2>

          <p className="attendance-subtitle">
            Fill in the attendance details below.
          </p>

          <div className="form-group">
            <label>Member Name</label>

            <input
              type="text"
              name="memberName"
              placeholder="Enter member name"
              value={formData.memberName}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Date</label>

            <input
              type="date"
              name="date"
              value={formData.date}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Status</label>

            <select
              name="status"
              value={formData.status}
              onChange={handleChange}
              required
            >
              <option value="Present">Present</option>

              <option value="Absent">Absent</option>
            </select>
          </div>

          <button className="attendance-save-btn" onClick={handleSubmit}>
            Save Attendance
          </button>
        </div>
      </div>
    </DashboardLayout>
  );
}
